import React from 'react';
import { getFileName } from 'helpers/FileCaching';
import globalJson from 'data/content.json';
import classes from './Share.module.scss';

import {
	FacebookShareButton,
	TwitterShareButton,
  } from 'react-share';

const iconsImages = require.context('assets/images/global/icons', true, /.*\.(gif|png|jpe?g|svg)$/i);

const Share = ({content, author, windowSize}) => {

	const onFbClick = (title) =>{
        window.gtag('event', "Facebook button clicked", {
		    'event_category': globalJson.tracking.ga_category,
			'event_label': title+ " Facebook button clicked",
			'value':10
		  });
	}

	const onTwClick = (title) =>{
        window.gtag('event', "Twitter button clicked", {
		    'event_category': globalJson.tracking.ga_category,
			'event_label': title+ " Twitter button clicked",
			'value':10
		  });
	
	}
	
	return(
		<div className={`container ${classes.Share}`}>
			<div className={`row`}>
				<div className={`col-8 col-lg-4 ${classes.Share__content}`}>
					<h2 className={classes.Share__title}>{content.title}</h2>
					<FacebookShareButton title={content.socialMessages.facebook} url={window.location.href}
						onClick={()=> onFbClick(content.socialMessages.facebook)}>
							<div className={`${classes.Share__icon}`}
								style={
									{
										backgroundImage: 'url(' + getFileName(iconsImages, 'iconFB.svg') + ')'
									}
								}>
							</div>
					</FacebookShareButton>
					<TwitterShareButton title={content.socialMessages.twitter} hashtags={content.twitterMeta.hashtags} via={content.twitterMeta.via} url={window.location.href}
						onClick={()=> onTwClick(content.socialMessages.twitter)}>
							<div className={`${classes.Share__icon}`}
								style={
									{
										backgroundImage: 'url(' + getFileName(iconsImages, 'iconTwitter.svg') + ')'
									}
								}>
							</div>
					</TwitterShareButton>
				</div>
			</div>
		</div>
	)

}

export default Share;